import * as React from 'react';


export default function TransactionHeader(props) {
  const { title, onBack, onHelp, hasInfo, isMain } = props;

  return (
    <div className="m__head app--md__box">

      <div className="m__head__left">
        {!isMain ? <a href="javascript:void(null)"
          className="m__head__anch"
          onClick={onBack}>
            <span className="i i-arw-l" />
          </a> :
          <a href="javascript:void(null)" className="m__head__logo">
            <span className="i i-logo" />
          </a>
        }
      </div>

      <div className="m__head__cent">
        {!hasInfo ? 
          <span className="m__head__titl">
            {title}
          </span> :
          <a href="javascript:void(null)" className="m__head__logo">
            <span className="i i-logo" />
          </a>
        }
      </div>

      <div className="m__head__right">
        <a href="javascript:void(null)"
           className="m__head__anch"
           onClick={onHelp}
        >
          <span className="i i-help" />
        </a>
      </div>
    </div>
  );
};
